'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var INTERCOM_OPERATIONS = exports.INTERCOM_OPERATIONS = {
    trackEvent: 'trackEvent',
    boot: 'boot',
    shutdown: 'shutdown',
    update: 'update',
    show: 'show',
    onUnreadCountChange: 'onUnreadCountChange'
};

var GOOGLE_ANALYTICS_OPERATIONS = exports.GOOGLE_ANALYTICS_OPERATIONS = {
    send: 'send'
};

var GOOGLE_ANALYTICS_HIT_TYPES = exports.GOOGLE_ANALYTICS_HIT_TYPES = {
    event: 'event'
};

var INTERCOM_SHOW_MESSAGES = exports.INTERCOM_SHOW_MESSAGES = 'INTERCOM_SHOW_MESSAGES';
var INTERCOM_SET_UNREAD_MESSAGES = exports.INTERCOM_SET_UNREAD_MESSAGES = 'INTERCOM_SET_UNREAD_MESSAGES';


//////////////////
// WEBPACK FOOTER
// ./src/client/analytics/analyticsConstants.js
// module id = 165
// module chunks = 0